import Page from "./index";

export default { path: "/home/tenant/role", component: Page };
